export const getTalkingPointListResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const isDataExist = response?.isDataExist;

  const talkingPoints = response?.talkingPoints?.map((item) => ({
    id: item?.id || '',
    isSpecialEvent: item?.isSpecialEvent || false,
    assignedHosts: item?.assignedHosts?.map((host) => host?.name) || [],
    createdAt: item?.createdAt || null,
    startTime: `${item?.startDate} ${item?.startTime ? item?.startTime : '00:00'}` || null,
    endTime: `${item?.endDate} ${item?.endTime ? item?.endTime : '23:59'}` || null,
    title: item?.title || '',
    isPublished: item?.isPublished || false,
    status: item?.status || null,
  }));

  return { talkingPoints, totalData, isDataExist };
};

export default getTalkingPointListResponse;
